import { Injectable, NgZone, ApplicationRef } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';

@Injectable()
export class ChangeDetectionInterceptor implements HttpInterceptor {
  constructor(
    private ngZone: NgZone,
    private appRef: ApplicationRef
  ) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      finalize(() => {
        this.ngZone.run(() => {
          this.appRef.tick();
        });
      })
    );
  }
}
